export default {
  team: {
    sendVerification: "Invia email di verifica",
    checkVerification: "Ho verificato la mia email",
    verificationSent: "Email di verifica inviata. Apri il link, poi torna qui.",

    rsvpIdentity: "Accedi con l’email verificata del tuo invito per rispondere. L’accesso RSVP non dà accesso al team organizzativo.",
    rsvpNoMatch: "Nessun invito RSVP attivo corrisponde a questa email. Usa l’account invitato o chiedi all’organizzatore di verificare l’indirizzo.",
    legacyLink: 'Questo vecchio link o PIN non dà più accesso al team. Chiedi al proprietario di invitare il tuo indirizzo email, poi apri Inviti ricevuti.',
    switchAccount: 'Usa un altro account',
  "title": "Team e accesso",
  "description": "Scegli chi può aiutarti e a quali sezioni può accedere per questo evento.",
  "myInvitations": "Inviti ricevuti",
  "ownerOnly": "Solo il proprietario può gestire il team. Seleziona un tuo evento per invitare qualcuno.",
  "invite": "Invita una persona",
  "retry": "Riprova",
  "members": "Persone con accesso",
  "owner": "Proprietario",
  "noMembers": "Per ora hai accesso solo tu. Invita qualcuno quando vuoi.",
  "editAccess": "Modifica accesso",
  "remove": "Rimuovi accesso",
  "invitations": "Inviti",
  "noInvitations": "Nessun invito in attesa.",
  "pending": "In attesa di accettazione",
  "cancelled": "Annullato",
  "expired": "Scaduto",
  "cancelInvite": "Annulla invito",
  "guestAccess": "E gli ospiti e i vecchi link?",
  "guestHelp": "Il team aiuta a organizzare. Questo accesso non invia inviti agli ospiti e non gestisce le risposte RSVP. I vecchi PIN e link non danno accesso al nuovo sistema del team.",
  "legacy": "Ci sono {{count}} vecchi accessi da verificare. Invita di nuovo le persone fidate via email, scegliendo le sezioni necessarie.",
  "unknownLegacy": "Vecchio accesso senza email affidabile: confermala con la persona.",
  "removeHelp": "Questa persona perderà l’accesso all’evento. I suoi contributi saranno conservati.",
  "cancelHelp": "L’invito viene annullato e l’accesso viene rimosso se è già stato accettato. I contributi vengono conservati.",
  "loadError": "Impossibile caricare gli accessi. Riprova.",
  "actionError": "Impossibile salvare. Controlla la connessione e riprova.",
  "email": "Indirizzo email",
  "role": "Livello di accesso",
  "view": "Può visualizzare",
  "edit": "Può modificare",
  "roleHelp": "Visualizzare: sola lettura. Modificare: aggiungere e aggiornare elementi. Solo il proprietario può eliminare elementi o gestire gli accessi.",
  "sections": "Quali sezioni?",
  "tasks": "Attività",
  "guests": "Ospiti",
  "budget": "Budget",
  "timeline": "Programma",
  "summary": "{{role}} · {{sections}} · {{event}}. L’accesso include tutti gli elementi di queste sezioni, anche quelli futuri.",
  "selectSections": "Seleziona almeno una sezione. Il budget viene condiviso solo se lo selezioni.",
  "identityHelp": "Gli inviti scadono dopo 7 giorni. Il destinatario deve accedere con questo indirizzo email verificato. Inoltrare l’email non dà accesso ad altre persone.",
  "send": "Invia invito",
  "sent": "Invito inviato. Puoi seguirne lo stato in Team e accesso.",
  "updated": "Accesso aggiornato.",
  "deliveryFailed": "L’invito è salvato, ma l’email non è stata consegnata. Il destinatario può accedere e aprire Inviti ricevuti.",
  "signIn": "Accedi per vedere i tuoi inviti",
  "verifyEmail": "Verifica il tuo indirizzo email e accedi di nuovo per vedere gli inviti.",
  "accept": "Accetta invito",
  "acceptError": "Impossibile accettare l’invito. Potrebbe essere scaduto o annullato.",
  "back": "Torna alla dashboard",
  "sharedEvent": "Condiviso con te",
  "openSection": "Apri {{section}}",
  "waiting": "Invito accettato. Caricamento dell’evento…",
  "sectionDenied": "Questa sezione non è inclusa nel tuo accesso. Chiedi al proprietario di modificare i permessi."
},
  review: {
    "notificationDraft": "Modifica le preferenze, poi salva le modifiche.",
    "markReadError": "Impossibile aggiornare le notifiche. Riprova."
},
  accountFlow: {
    "proTitle": "Il tuo piano: Pro",
    "proHelp": "Gestisci qui eventi, abbonamento e fatture.",
    "manageEvents": "Gestisci i miei eventi",
    "unsaved": "Modifiche non salvate",
    "instantPreferences": "Le preferenze vengono applicate subito.",
    "comparePlans": "Confronta i piani",
    "activeEvent": "Evento attuale",
    "openEvent": "Apri",
    "editDetails": "Modifica dettagli",
    "switchError": "Impossibile cambiare evento. Riprova."
},
  organization: {
    "vendorOverview": "Panoramica dei fornitori",
    "grid": "Griglia",
    "noVendors": "Nessun fornitore corrispondente",
    "resetHelp": "Modifica la ricerca o reimposta i filtri per vedere i fornitori.",
    "seatingProgress": "{{placed}} assegnati · {{remaining}} da assegnare",
    "firstTable": "Crea il tuo primo tavolo",
    "tableHelp": "Aggiungi un tavolo per assegnare gli ospiti o genera automaticamente una disposizione.",
    "addTable": "Aggiungi tavolo"
},
  workflow: {
    "scheduleExists": "Le fasi già presenti nel programma non verranno aggiunte di nuovo.",
    "taskView": "Vista attività",
    "list": "Lista",
    "kanban": "Bacheca",
    "noTasksMatch": "Nessuna attività corrispondente",
    "resetTaskHelp": "Modifica la ricerca o reimposta i filtri per ritrovare le attività.",
    "previewSchedule": "Anteprima del programma",
    "scheduleHelp": "Questo modello di matrimonio aggiunge le fasi qui sotto al programma esistente. Potrai poi modificare orari e descrizioni.",
    "applySchedule": "Aggiungi queste fasi"
},
  journey: {
    "guestActions": "Gestisci ospiti",
    "openSeating": "Apri la disposizione dei tavoli",
    "moreGuestActions": "Condivisione, RSVP e altro",
    "noGuestResults": "Nessun ospite corrispondente",
    "changeGuestSearch": "Modifica la ricerca o reimposta i filtri per ritrovare gli ospiti.",
    "firstGuestHelp": "Aggiungi il primo ospite o importa la lista da un file CSV.",
    "estimatorOptional": "La stima ti aiuta a pianificare il budget. Puoi anche iniziare dalle spese e tornare qui più tardi.",
    "skipEstimator": "Vai alle spese"
},
  planning: {
    "eyebrow": "Il tuo spazio di organizzazione",
    "description": "Consulta le priorità e procedi al tuo ritmo.",
    "actions": "Azioni di pianificazione",
    "tasks": "Le mie attività",
    "guests": "Ospiti",
    "budget": "Budget",
    "pendingCount": "{{count}} da fare",
    "completedCount": "{{count}} completate",
    "noDueDate": "Senza scadenza",
    "overdue": "In ritardo",
    "allDone": "Tutto fatto: tutte le attività sono completate."
},
  title: "Dashboard",
  welcome: "Benvenuto nella tua dashboard matrimoniale",
  daysLeft: "{{days}} giorni rimanenti",
  progress: {
    daysLeft: "{{count}} giorni rimanenti"
  },
  overallProgress: "Progresso generale",
  tasksCompleted: "Attività completate",
  guestsConfirmed: "Ospiti confermati",
  budgetUsed: "Budget utilizzato",
  widgets: {
    progress: "Progresso",
    tasks: {
      title: "Attività",
      emptyTitle: "Inizia a organizzare",
      emptyDescription: "Aggiungi le prime attività per iniziare a organizzare il tuo matrimonio",
      addButton: "Aggiungi attività",
      completed: "Completato",
      inProgress: "In corso",
      pending: "Da fare",
      overdue: "In ritardo"
    },
    guests: {
      title: "Ospiti",
      emptyTitle: "Gestisci i tuoi ospiti",
      emptyDescription: "Inizia a creare la tua lista degli invitati",
      addButton: "Aggiungi ospite",
      confirmed: "Confermati",
      pending: "In attesa",
      declined: "Rifiutati",
      total: "Totale"
    },
    budget: {
      title: "Budget",
      emptyTitle: "Gestisci il tuo budget",
      emptyDescription: "Inizia a monitorare le tue spese",
      addButton: "Aggiungi una spesa",
      spent: "Speso",
      remaining: "Rimanente",
      total: "Totale",
      currency: "€"
    },
    timeline: {
      title: "Sequenza temporale",
      emptyTitle: "Crea la tua sequenza temporale",
      emptyDescription: "Aggiungi i momenti chiave del tuo matrimonio",
      addButton: "Aggiungi evento",
      daysLeft: "{{count}} giorni rimanenti",
      today: "Oggi",
      upcoming: "In arrivo"
    },
    vendors: "Fornitori",
    checklist: "Lista di controllo"
  },
  stats: {
    totalGuests: "Totale ospiti",
    totalTasks: "Totale attività",
    totalBudget: "Budget totale",
    totalVendors: "Totale fornitori",
    tasksCompleted: "Attività completate",
    guestsConfirmed: "Ospiti confermati",
    budgetSpent: "Budget speso",
    daysLeft: "Giorni rimanenti"
  },
  quickActions: {
    addTask: "Aggiungi attività",
    addGuest: "Aggiungi ospite",
    addExpense: "Aggiungi spesa",
    addVendor: "Aggiungi fornitore",
    title: "Azioni rapide",
    addEvent: "Aggiungi evento"
  },
  countdown: {
    title: "Conto alla rovescia",
    noDate: "Nessuna data configurata",
    dayJ: "Giorni",
    dayJ_zero: "Il grande giorno",
    dayJ_one: "Giorno",
    dayJ_other: "Giorni",
    hoursJ: "ore",
    hoursJ_zero: "ora",
    hoursJ_one: "ora",
    hoursJ_other: "ore",
    minutesJ: "minuti",
    minutesJ_zero: "minuto",
    minutesJ_one: "minuto",
    minutesJ_other: "minuti"
  },
  eventDetails: {
    title: "Dettagli evento",
    subtitle: "{{count}} dettaglio(i) da completare",
    complete: "Tutti i dettagli sono completi",
    partners: "Partner",
    location: "Posizione",
    budget: "Budget",
    highPriority: "Priorità alta",
    mediumPriority: "Priorità media",
    lowPriority: "Priorità bassa",
    partner1: "Partner 1",
    partner2: "Partner 2",
    venue: "Luogo",
    venuePlaceholder: "Nome del luogo",
    address: "Indirizzo",
    addressPlaceholder: "Indirizzo completo",
    city: "Città",
    cityPlaceholder: "Città",
    totalBudget: "Budget totale",
    guestCount: "Numero ospiti",
    edit: {
      partners: "Modifica partner",
      location: "Modifica posizione",
      budget: "Modifica budget"
    }
  },
  budgetWidget: {
    title: "Budget",
    subtitle: "Riepilogo budget",
    configure: "Configura il tuo budget per vedere le statistiche",
    configureButton: "Configura"
  },
  guestsWidget: {
    title: "Ospiti",
    total: "Totale",
    manage: "Gestisci",
    responseRate: "Tasso di risposta",
    estimatedProgress: "Progresso stimato",
    confirmed: "Confermati",
    pending: "In attesa",
    declined: "Rifiutati",
    children: "Bambini",
    teens: "Adolescenti",
    emptyTitle: "Nessun ospite",
    emptyDescription: "Inizia a creare la tua lista ospiti",
    addButton: "Aggiungi ospite"
  },
  tasks: {
    title: "Attività",
    pending: "In attesa",
    viewAll: "Visualizza tutto",
    completed: "Completate",
    noPending: "Nessuna attività in attesa",
    empty: {
      title: "Nessuna attività",
      description: "Inizia a organizzare il tuo evento aggiungendo attività",
      action: "Aggiungi attività"
    },
    categories: {
      legal: "Amministrativo",
      venue: "Luogo",
      other: "Altro",
      planning: "Pianificazione",
      guests: "Ospiti"
    }
  },
  progressWidget: {
    title: "Progresso",
    global: "Progresso globale",
    daysLeft: "{{count}} giorni rimanenti",
    tasks: "Attività",
    budget: "Budget",
    guests: "Ospiti",
    checklist: "Lista di controllo",
    noData: "Nessun dato disponibile"
  },
  checklistWidget: {
    title: "Lista di controllo",
    empty: {
      title: "Nessuna attività",
      description: "Inizia a creare la tua lista di controllo",
      action: "Crea lista"
    },
    subtitle: "I tuoi progressi",
    noImportant: "Nessuna attività importante"
  },
  timelineWidget: {
    title: "Cronologia",
    subtitle: "Prossimi eventi",
    empty: "Nessun prossimo evento"
  },
  weatherWidget: {
    title: "Meteo",
    setLocation: "Imposta posizione",
    addWeather: "Aggiungi meteo",
    searchReception: "Cerca luogo ricevimento",
    noData: "Nessun dato meteorologico disponibile",
    humidity: "umidità",
    rain: "pioggia",
    currentConditions: "Condizioni attuali a {{location}}",
    historicalTitle: "Dati storici",
    historicalNote: "Dati meteorologici storici per la data del tuo evento"
  },
  notificationsWidget: {
    title: "Notifiche",
    unread: "{{count}} non lette",
    viewAll: "Visualizza tutto",
    markAsRead: "Segna come letto",
    empty: "Nessuna notifica",
    allRead: "Tutte le notifiche sono state lette"
  },
  recentActivity: "Attività recente",
  upcomingTasks: "Prossime attività",
  guestsSummary: "Riepilogo ospiti",
  budgetSummary: "Riepilogo budget",
  noUpcomingTasks: "Nessuna prossima attività",
  noRecentActivity: "Nessuna attività recente",
  customize: "Personalizza dashboard",
  layout: "Layout",
  themes: "Temi",
  preferences: "Preferenze",
  vendorsWidget: {
    title: "Fornitori",
    subtitle: "Gestisci i tuoi fornitori",
    emptyTitle: "Nessun fornitore ancora",
    emptyDescription: "Inizia aggiungendo il tuo primo fornitore per vederlo qui.",
    searchVendors: "Cerca fornitori",
    add: "Aggiungi",
    total: "{{count}} fornitore/i",
    addVendor: "Aggiungi un fornitore"
  },
  description: "Gestisci il tuo matrimonio a colpo d'occhio",
  noEventSelected: "Nessun evento selezionato",
  subtitle: "Panoramica del tuo evento",
  gridView: "Vista griglia",
  listView: "Vista elenco",
  usage: "Utilizzo",
  "Arrivée des invités": "Arrivo degli ospiti",
  "Cérémonie": "Cerimonia",
  Cocktail: "Cocktail",
  "Dîner": "Cena",
  "Soirée": "Serata",
  "Préparation": "Preparazione",
  account: {
    title: "Account"
  },
  errors: {
    loadingError: "Errore durante il caricamento dei dati",
    noEventFound: "Nessun evento trovato",
    markAsRead: "Errore durante il contrassegno come letto"
  },
  timeline: {
    examples: {
      preparation: {
        title: "Preparazione"
      },
      ceremony: {
        title: "Cerimonia"
      },
      cocktail: {
        title: "Cocktail"
      },
      dinner: {
        title: "Cena"
      },
      party: {
        title: "Serata"
      }
    }
  }
};
